import { MessageCircle } from "lucide-react";
import { COMPANY } from "../data/content";

export const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${COMPANY.phoneRaw.replace("+", "")}?text=${encodeURIComponent(
      "Hello Subhankara, I want to discuss a project."
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat on WhatsApp"
    className="group fixed bottom-6 right-6 z-40 flex items-center gap-0 border border-navy/20 bg-[#25D366] text-white shadow-[4px_4px_0_0_#002244] transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-[6px_6px_0_0_#002244]"
  >
    <span className="flex h-14 w-14 items-center justify-center">
      <MessageCircle size={26} fill="currentColor" />
    </span>
    <span className="max-w-0 overflow-hidden whitespace-nowrap font-mono text-xs font-bold uppercase tracking-[0.15em] transition-[max-width,padding] duration-300 group-hover:max-w-[160px] group-hover:pr-5">
      Chat with us
    </span>
  </a>
);
